import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-saintbrand-features-grid.js';

const FEATURE_ICON = `<svg class="feature-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.10477 7.65644L5.08502 6.59479C5.0012 6.50167 4.89877 6.45509 4.77769 6.45509C4.65663 6.45509 4.54955 6.497 4.4564 6.58082C4.36328 6.67393 4.31671 6.78105 4.31671 6.90211C4.31671 7.02317 4.36328 7.13029 4.4564 7.2234L5.81142 8.56445C5.89524 8.6483 5.99302 8.69015 6.10477 8.69015C6.21653 8.69015 6.31431 8.6483 6.39813 8.56445L8.95449 6.02204C9.03835 5.93822 9.0802 5.83577 9.0802 5.71472C9.0802 5.59366 9.0337 5.49121 8.94057 5.4074C8.85671 5.33288 8.75665 5.29796 8.64023 5.30262C8.52381 5.30729 8.42831 5.34685 8.35382 5.42137L6.10477 7.65644ZM4.638 12.5318L3.7719 11.051L2.03972 10.7017C1.93727 10.6831 1.85113 10.6272 1.78128 10.5341C1.71144 10.441 1.68583 10.3433 1.70445 10.2408L1.90002 8.56445L0.79645 7.27928C0.721943 7.20477 0.684692 7.11165 0.684692 6.9999C0.684692 6.88814 0.721943 6.79502 0.79645 6.72051L1.90002 5.4493L1.70445 3.77298C1.68583 3.67053 1.71144 3.57275 1.78128 3.47963C1.85113 3.38651 1.93727 3.33064 2.03972 3.312L3.7719 2.96277L4.638 1.46805C4.69387 1.37492 4.77305 1.30973 4.87548 1.27248C4.97793 1.23523 5.08038 1.23988 5.1828 1.28645L6.70545 1.99888L8.22811 1.28645C8.33054 1.23988 8.43303 1.2329 8.53545 1.2655C8.63787 1.29809 8.71701 1.36095 8.77293 1.45408L9.65295 2.96277L11.3712 3.312C11.4737 3.33064 11.5598 3.38651 11.6296 3.47963C11.6995 3.57275 11.7251 3.67053 11.7065 3.77298L11.5109 5.4493L12.6145 6.72051C12.689 6.79502 12.7262 6.88814 12.7262 6.9999C12.7262 7.11165 12.689 7.20477 12.6145 7.27928L11.5109 8.56445L11.7065 10.2408C11.7251 10.3433 11.6995 10.441 11.6296 10.5341C11.5598 10.6272 11.4737 10.6831 11.3712 10.7017L9.65295 11.051L8.77293 12.5457C8.71701 12.6388 8.63787 12.7017 8.53545 12.7343C8.43303 12.7669 8.33054 12.7599 8.22811 12.7133L6.70545 12.0009L5.1828 12.7133C5.08038 12.7599 4.97793 12.7645 4.87548 12.7273C4.77305 12.6901 4.69387 12.6249 4.638 12.5318Z" fill="#121212"></path>
</svg>`;

const defaultItems = [
  { text: '<p>Fits Over Prescription Glasses</p>' },
  { text: '<p>Polarized UV Protection</p>' },
  { text: '<p>Lightweight Modern Design</p>' },
  { text: '<p>No Pressure or Bulk</p>' },
];

const renderItem = item => `
  <div data-attribute="item" class="saintbrand-features-grid-item">
    <div class="saintbrand-features-grid-icon">
      ${FEATURE_ICON}
    </div>
    <div data-attribute="text-item" class="saintbrand-features-grid-text">
      ${item.text || ''}
    </div>
  </div>`;

const contentHtml = `
  <div class="wrap-saintbrand-features-grid" data-attribute="saintbrand-features-grid-content">
    <div
      class="saintbrand-features-grid"
      data-attribute="saintbrand-features-grid"
      data-columns="2"
      data-gap="16"
      style="--columns: 2; --gap: 16px;"
    >
      ${defaultItems.map(renderItem).join('')}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: false,
  bottomPadding: false,
});
